import { useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import fetch from 'features/common/fetch';
import campaigns from 'features/views/campaignDashboards/campaigns';
import dashboardSidebar from 'features/views/campaignDashboards/sidebar';
import dashboardStructure from 'features/views/campaignDashboards/structure';
import contacts from 'features/views/contacts';
import ContactsTable from 'pages/CampaignDashboards/components/ContactsTable';

const { urls } = fetch.constants;

export const DashboardPpz = () => {
	const dispatch = useDispatch();

	const campaignId = useSelector(dashboardStructure.selectors.getCampaignId);
	const organizationStructure = useSelector(dashboardStructure.selectors.getStructure);
	const campaign = useSelector((state) => campaigns.selectors.getCampaignById(state, campaignId));

	useEffect(() => {
		if (!isEmpty(campaign)) {
			dispatch(dashboardSidebar.actions.fetchSummary(campaign, urls.dashboardPpzSummary, organizationStructure));
			// fetch contacts
			dispatch(
				contacts.actions.loadContacts('dashboard-ppz')(
					{
						campaign: campaign.id,
						isForDashboard: true,
						dashboardContactSite: 'PPZ',
						ppz: organizationStructure[0].ppz,
					},
					'orderingClientName',
				),
			);
		}
		// eslint-disable-next-line
	}, [dispatch, campaign]);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('dashboardPpz:contacts')} />
				<ContactsTable view="dashboard-ppz" campaign={campaign} />
			</Stack>
		</Paper>
	);
};

export default DashboardPpz;
